const icons = new Map();
icons.set('error', 'circleExclamation');
icons.set('success', 'circleCheck');
icons.set('blank', 'triangleExclamation');
icons.set('custom', 'triangleExclamation');
icons.set('loading', 'triangleExclamation');

const toast = (handle) => icons.get(handle);

export default toast;
